import { connect } from "react-redux";
import React, { Component } from "react";
import Modal from "../../utils/customModal";
import { ReactTitle } from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Tabs from "../../public/tableProvider/tabs";
import { getRoles, getSessionCountry } from "../../../Redux/reducer/session";
import { getCreditLine } from "../../../Redux/reducer/credit-line";
import { moduleAction, urlParam, loadingHtml } from "../../utils/functions";

import ByStatus from "./lists/byStatus";
import DraftList from "./lists/DraftList";
import ApprovalsList from "./lists/approvals";
import CreditLine from "../creditLine/creditLine";
import MainTemplate from "../../public/mainTemplate";
import { EXECUTE, MOD_BILL, WRITE } from "../../../permissions";
import { handleWorkingHours } from "../../utils/utilities";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import {
  getUserHolidayByCountry,
  workingHoursHandler,
} from "../../../Redux/actions/userActions";
import {
  getHolidayStatus,
  getHolidaysByCountry,
  getisWithinWorkingHours,
} from "../../../Redux/reducer/users";

const pageSizeItems = [
  { name: "10", value: 10 },
  { name: "20", value: 20 },
  { name: "35", value: 35 },
];

const defaultBillSelection = {
  totalBillSelection: 0,
  currency: {
    CRC: {
      name: "Colones",
      symbol: "₡",
      totalBillSelection: 0,
      totalBillAmount: 0,
      billTypeSelection: {
        discount: {
          totalBillSelection: 0,
          totalBillAmount: 0,
        },
        paymentMaturity: {
          totalBillSelection: 0,
          totalBillAmount: 0,
        },
      },
    },
    USD: {
      name: "Dólares",
      symbol: "$",
      totalBillSelection: 0,
      totalBillAmount: 0,
      billTypeSelection: {
        discount: {
          totalBillSelection: 0,
          totalBillAmount: 0,
        },
        paymentMaturity: {
          totalBillSelection: 0,
          totalBillAmount: 0,
        },
      },
    },
  },
};

const EMPTY_ARRAY = []

const byStatusExcludedStatus = [
  "EXPIRED",
  "ERROR",
  "VALIDATED",
  "CANCELLED",
  "PAID",
  "PROCESSED",
  "REJECTED_DELETE",
  "INACTIVE",
  "DELETE_PENDING",
  "PAID_REJECTED",
  "ACCEPTED_PARTIALLY",
];

export class Bill extends Component {
  constructor(props) {
    super(props);
    var activeTab =
      props.match.path == "/bills/all" ? props.t("invoices.tabs.bystates") : "";
    this.state = {
      holdMount: {},
      modal: true,
      searchFilters: false,
      stateFilters: [],
      activeTab,
      tabSelected: props.match.path == "/bills/all" ? "by-status" : "draft",
      pageSize: pageSizeItems[0].value,
      billSelection: JSON.parse(JSON.stringify(defaultBillSelection)),
    };
  }

  setModal = (modal, tabSelected) => {
    this.setState({ modal, tabSelected });
  };

  search = (searchProperty, serachTerm = "") => {
    this.setState({billSelection: defaultBillSelection});
    var actionFilters = [];

    if (serachTerm !== "") {
      // Realizamos la busqueda por filtros
      var operator = "";
      var filters = this.getFilters();
      filters.map((item) => {
        if (item.property == searchProperty) {
          operator = item.operator;
        }
      });
      actionFilters = [
        { property: searchProperty, operator: operator, value: serachTerm },
      ];

      this.setState({ searchFilters: true, stateFilters: actionFilters });
    } else {
      this.setState({ searchFilters: false, stateFilters: [] });
    }
  };

  updateHoldMount = (
    currency,
    mount,
    operation,
    reset = false,
    companyId = null
  ) => {
    var { holdMount } = this.state;
    if (reset) {
      // holdMount[currency] = 0;
      holdMount = {};
    } else {
      if (companyId !== null && holdMount[companyId] === undefined) {
        holdMount[companyId] = {};
      }
      let statemount =
        companyId !== null
          ? holdMount[companyId][currency] || 0
          : holdMount[currency] || 0;
      var amount = operation ? statemount + mount : statemount - mount;

      if (companyId !== null) {
        holdMount[companyId][currency] =
          Math.round((amount + Number.EPSILON) * 100) / 100;
      } else {
        holdMount[currency] = Math.round((amount + Number.EPSILON) * 100) / 100;
      }
    }

    this.setState({ holdMount });
  };

  handleWorkingHours = (statusOk) => {
    const { countryCode, holidaysByCountryCode } = this.props;

    if (holidaysByCountryCode?.isHoliDay || !statusOk) {
      this.props.workingHoursHandler({
        isWithinWorkingHours: false,
        holidayStatusOk: statusOk,
      });

      return;
    }

    const isWithinWorkingHours = handleWorkingHours(countryCode);

    this.props.workingHoursHandler({
      isWithinWorkingHours,
      holidayStatusOk: statusOk,
    });
  };

  handleHolidays = async () => {
    const { countryCode } = this.props;
    let statusOk = false;
    if (this.state.tabSelected !== "by-status") {
      try {
        await this.props.getUserHolidayByCountry(countryCode);
        statusOk = true;
      } finally {
        this.handleWorkingHours(statusOk);
      }
    } else {
      this.props.workingHoursHandler({
        isWithinWorkingHours: true,
        holidayStatusOk: true,
      });
    }
  };

  componentDidMount() {
    const { countryCode } = this.props
    defaultBillSelection.currency.CRC.show = countryCode === "CR" ? true : false;
    defaultBillSelection.currency.USD.show = true;

    this.handleBillSelection(defaultBillSelection);
    this.handleHolidays();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabSelected !== this.state.tabSelected) {
      this.handleHolidays();
    }
  }

  getFilters() {
    const { t, lines } = this.props;

    var filters = [
      {
        name: t("general.filters.name"),
        property: "provider.institution.name",
        operator: "eq",
      },
      {
        name: t("general.filters.identification"),
        property: "provider.institution.businessId",
        operator: "eq",
      },
    ];

    if (lines.length > 0) {
      filters.push({ name: "Moneda", property: "currency", operator: "eq" });
    }

    return filters;
  }

  reset = () => {
    this.updateHoldMount(null, null, null, true);
  };

  handlePageSizeSelection = (pageSize) => {
    this.setState({ pageSize });
  };

  handleBillSelection = (billSelection) => {
    this.setState({ billSelection });
  };

  TableBill = () => {
    const { stateFilters } = this.state;
    const { roles, location, t } = this.props;
    const param = urlParam(location.search, "status");
    const filter = null !== param ? param : "";

    let Add,
      aproval = {};
    if (moduleAction(roles, MOD_BILL, WRITE) === true) {
      Add = { buttonLbl: t("invoices.add"), buttonLnk: "/bills/add" };
    }
    if (moduleAction(roles, MOD_BILL, EXECUTE) === true) {
      aproval = {
        label: t("invoices.tabs.approvals"),
      };
    }

    const filters = this.getFilters();

    return (
      <React.Fragment>
        <ReactTitle title={`${t("invoices.meta.title")} - ${t("appName")}`} />
        <CreditLine
          CurrencyMounts={this.state.holdMount}
          key={this.state.tabSelected}
        />
        {!this.props?.isWithinWorkingHours &&
          this.props?.holidayStatus &&
          this.state.tabSelected !== "by-status" && (
            <AlertBanner type="error" className="alertMsg">
              {t(
                `invoices.errors.${
                  this.props.countryCode === "PA"
                    ? "notInWorkingHoursPA"
                    : "notInWorkingHoursCr"
                }`
              )}
            </AlertBanner>
          )}
        {!this.props?.holidayStatus &&
          this.state.tabSelected !== "by-status" && (
            <AlertBanner type="error" className="alertMsg">
              {t(
                `invoices.errors.${
                  this.props.countryCode === "CR"
                    ? "holiday_request_failed_CR"
                    : "holiday_request_failed_PA"
                }`
              )}
            </AlertBanner>
          )}
        <Tabs
          {...Add}
          activeTab={this.state.activeTab}
          filterItems={filters}
          filterSearch={this.search}
          pageSize={this.state.pageSize}
          pageSizeItems={pageSizeItems}
          handlePageSizeSelection={this.handlePageSizeSelection}
          billSelection={this.state.billSelection}
        >
          <div key="draft" label={t("invoices.tabs.draft")}>
            <DraftList
              filters={stateFilters}
              pageSize={this.state.pageSize}
              handlePageSizeSelection={this.handlePageSizeSelection}
              setModal={(modal) => this.setModal(modal, "draft")}
              updateCreditLine={this.updateHoldMount}
              defaultBillSelection={defaultBillSelection}
              billSelection={this.state.billSelection}
              handleBillSelection={this.handleBillSelection}
              excludedStatus={EMPTY_ARRAY}
            />
          </div>
          <div key="by-status" label={t("invoices.tabs.bystates")}>
            <ByStatus
              filters={stateFilters}
              pageSize={this.state.pageSize}
              handlePageSizeSelection={this.handlePageSizeSelection}
              setModal={(modal) => this.setModal(modal, "by-status")}
              byStatus={filter}
              reset={this.reset}
              defaultBillSelection={defaultBillSelection}
              billSelection={this.state.billSelection}
              handleBillSelection={this.handleBillSelection}
              excludedStatus={byStatusExcludedStatus}
            />
          </div>
          <div key="approved" label="" {...aproval}>
            <ApprovalsList
              filters={stateFilters}
              pageSize={this.state.pageSize}
              handlePageSizeSelection={this.handlePageSizeSelection}
              setModal={(modal) => this.setModal(modal, "approved")}
              reset={this.reset}
              defaultBillSelection={defaultBillSelection}
              billSelection={this.state.billSelection}
              handleBillSelection={this.handleBillSelection}
              excludedStatus={EMPTY_ARRAY}
            />
          </div>
        </Tabs>
      </React.Fragment>
    );
  };

  render() {
    return (
      <MainTemplate className="wrapper-bill">
        {this.TableBill()}
        <Modal show={this.state.modal}>{loadingHtml()}</Modal>
      </MainTemplate>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    lines: getCreditLine(state),
    countryCode: getSessionCountry(state),
    holidaysByCountryCode: getHolidaysByCountry(state),
    isWithinWorkingHours: getisWithinWorkingHours(state),
    holidayStatus: getHolidayStatus(state),
  };
};

export const mapDispatch = (dispatch) => ({
  getUserHolidayByCountry: (payload) =>
    dispatch(getUserHolidayByCountry(payload)),
  workingHoursHandler: (payload) => dispatch(workingHoursHandler(payload)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(Bill))
);
